export const getSwitchOverrides = theme => {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          height: 24,
          width: 44,
          padding: 0,
          marginRight: 10
        },
        track: {
          borderRadius: 24 / 2,
          opacity: 1
        },
        switchBase: {
          padding: 2,
          color: theme.palette.primary.dark,
          "&+.MuiSwitch-track": {
            opacity: 0.7,
            backgroundColor: theme.palette.primary.dark
          },
          "&.Mui-disabled": {
            color: theme.palette.primary.light,
            opacity: 1,
            "&+.MuiSwitch-track": {
              opacity: 0.38,
              backgroundColor: theme.palette.primary.dark
            },
            ".MuiSwitch-thumb": {
              opacity: 0.9
            }
          },
          "&.Mui-checked": {
            transform: "translateX(20px)",
            "&+.MuiSwitch-track": {
              opacity: 1,
              backgroundColor: theme.palette.primary.light
            },
            "&.Mui-disabled": {
              color: theme.palette.secondary.light,
              opacity: 1,
              "&+.MuiSwitch-track": {
                opacity: 0.38,
                backgroundColor: theme.palette.primary.light
              }
            }
          }
        },
        thumb: {
          boxShadow: "none",
          width: 20,
          height: 20,
          margin: 0,
          color: theme.palette.primary.contrastText
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          marginLeft: 0,
          width: 44
        }
      }
    }
  };
};